import React, {Component, ReactElement} from 'react'
import {Location} from 'react-router-dom'
import {Colors, FontSize, FontWeights} from '../../../styledComponents/Constants';
import {Nullable} from '../../../app/TypeHelpers';
import {BlockSpacer, currentMedia} from '../../../styledComponents/ResponsiveConvenience';
import {StyledPageTitle} from '../../../components/reservations/components/CommonStyle';
import {Box, Collapse} from '@mui/material';
import {getQueryParameter, judgeAuthorityCheck} from '../../common/util/Natutil';
import {HKConstants} from '../../../HKConstants'
import {
    createResidentWithErrorHandlingPage,
    ResidentWithErrorHandlingPagePropsSet
} from '../../../components/shared/hoc/createResidentWithErrorHandlingPage'
import {NatGetResidentBillingAmountLatest} from './repository/NatGetResidentBillingAmountLatest'
import {NatGetResidentBillingAmountDetail} from './repository/NatGetResidentBillingAmountDetail'
import {SecondaryButton, StyledSecondaryButton, UnstyledLinkStyledButton} from '../../../styledComponents/Button'
import {LOGIN_MODE, PAYMENT_STATUES, RESIDENT_USER_TYPE} from '../../../CodeMaster'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {ResidentLoginInfoSessionStorageKey} from '../../common/authentication/NatResidentLoginInfoSessionStorageHelper'
import NatResidentUserRepo from '../residentUser/repository/NatResidentUserRepo'
import styled from 'styled-components'
import {
    FullWidthLeftRowFlexContainer,
    RightRowFlexContainer,
    RowFlexContainer
} from '../../../styledComponents/FlexComponents'
import NatAmountFixRepo from './repository/NatAmountFixRepo'
import {DisplayItemTitle} from '../../../styledComponents/DisplayItem'
import {
    BigFontBold,
    Divider,
    ExtraBigFontBold,
    Headline,
    MiddleFontBold,
    PlainForwardLinkStyledButton,
    PlainLinkStyledBackButton,
    SelectArea,
    SelectIcon,
    SmallExpandButton,
    StatusSpan,
    StyledLink,
    WhiteArea
} from './common/BillingDataCommon'
import {ListGridContainer} from '../applications/common/resident/NatResidentApplicationsCommon'
import NatResidentBillingDataContactUs from './common/NatResidentBillingDataContactUs'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faFilePdf} from '@fortawesome/free-solid-svg-icons'
import {Close, GetApp} from '@mui/icons-material'
import {getFormattedYearMonth, getFormattedYearMonthDay} from '../common/NatDateFormatted'
import ResponsiveDialog from '../../../components/shared/ResponsiveDialog'
import {NatPutBillingAmountFixAlreadyViewRequest} from './repository/NatPutBillingAmountFixAlreadyView'
import {
    HeadingAreaMessageComponentForResident
} from '../../../components/shared/pageBaseComponents/HeadingAreaMessageComponentForResident'
import NatResidentBillingDetailItem from './common/NatResidentBillingDetailItem'
import {Messages} from '../../../Messages';
import PreformattedDiv from '../../../styledComponents/PreformattedDiv';
import {WideMainContainer} from '../../../styledComponents/ContentsArea';

const KEY_SELECTED_RIDGE_CD: string = 'selectedRidgeCd'
const KEY_SELECTED_ROOM_NUMBER: string = 'selectedRoomNumber'
const KEY_USER_ID: string = 'userId'

interface Props {
    condominiumCd: string,
    residentUserRepo: NatResidentUserRepo
    amountFixRepo: NatAmountFixRepo,
    location: Location
}

interface States {
    ridgeCd: string,
    roomNumber: string,
    seq: Nullable<number>,
    billingYearMonthList: Nullable<string[]>,
    billingAmountLatest: Nullable<NatGetResidentBillingAmountLatest>,
    billingAmountDetail: Nullable<NatGetResidentBillingAmountDetail>,
    currentYearMonthIndex: number,
    isTradingDetailOpen: boolean,
    isBreakdownOpen: boolean[],
    mainUserName: string,
    isSubUser: boolean,
    isAdminUser: boolean,
    haveAuthViewBillingAmount: boolean,
    haveAuthIssueReceipt: boolean,
    dialogStatus: boolean,
    isNotPayComplete: boolean,
    isLoadCompleted: boolean,
    maintenanceMessage: string
}

class NatResidentBillingAmountConfirmPage extends Component<Props & ResidentWithErrorHandlingPagePropsSet, States> {

    constructor(props: Props & ResidentWithErrorHandlingPagePropsSet) {
        super(props);

        const userType = SessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.LOGIN_USER_RESIDENT_USER_TYPE)
        const isAdminUser = SessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.LOGIN_MODE) === LOGIN_MODE.ADMIN.value

        this.state = {
            ridgeCd: SessionStorageHelper.getStringItemOrNull(KEY_SELECTED_RIDGE_CD) ?? '',
            roomNumber: SessionStorageHelper.getStringItemOrNull(KEY_SELECTED_ROOM_NUMBER) ?? '',
            seq: null,
            billingYearMonthList: null,
            billingAmountLatest: null,
            billingAmountDetail: null,
            currentYearMonthIndex: 0,
            isTradingDetailOpen: true,
            isBreakdownOpen: [],
            mainUserName: '',
            isSubUser: userType === RESIDENT_USER_TYPE.SUB.value,
            isAdminUser: isAdminUser,
            haveAuthViewBillingAmount: judgeAuthorityCheck(HKConstants.CMN.AUTH.VIEW_BILLING_AMOUNT),
            haveAuthIssueReceipt: judgeAuthorityCheck(HKConstants.CMN.AUTH.ISSUE_RECEIPT) || isAdminUser,
            dialogStatus: false,
            isNotPayComplete: false,
            isLoadCompleted: false,
            maintenanceMessage: '',
        };
        this.receiptIssueButtonClick = this.receiptIssueButtonClick.bind(this);
        this.prevMonthClick = this.prevMonthClick.bind(this);
        this.nextMonthClick = this.nextMonthClick.bind(this);
        this.handleBillingYearMonthChange = this.handleBillingYearMonthChange.bind(this)
        this.tradingDetailClick = this.tradingDetailClick.bind(this)
        this.breakdownOpenClick = this.breakdownOpenClick.bind(this)
        this.handleDialogClick = this.handleDialogClick.bind(this)
        this.handleDialogCancelClick = this.handleDialogCancelClick.bind(this)
        this.invoiceFileClick = this.invoiceFileClick.bind(this)
    }

    async componentDidMount(): Promise<void> {
        const {amountFixRepo, condominiumCd, eventEmitter} = this.props
        const {
            ridgeCd, roomNumber, currentYearMonthIndex,
            haveAuthViewBillingAmount, haveAuthIssueReceipt, isSubUser, isAdminUser
        } = this.state

        await this.props.eventEmitter.showLoading();
        try {
            if (haveAuthViewBillingAmount) {
                // 請求年月一覧を取得
                const billingYearMonthList = await this.props.asyncCallFunction(
                    this.props.amountFixRepo.getBillingYearMonthList.bind(
                        amountFixRepo, condominiumCd, ridgeCd, roomNumber),
                    (httpErrorOrNetworkError) => {
                        if (httpErrorOrNetworkError.responseBody.requestError.messageId === Messages.ESYCC0027.id) {
                            this.setState({
                                maintenanceMessage: Messages.ESYCC0027.message
                            })
                        } else {
                            eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                        }
                    })

                if (billingYearMonthList?.details && billingYearMonthList.details.length > 0) {
                    // 最新請求金額を取得
                    const billingAmountLatest = await this.props.asyncCallFunction(
                        this.props.amountFixRepo.getBillingAmountLatest.bind(
                            amountFixRepo, condominiumCd, ridgeCd, roomNumber),
                        (httpErrorOrNetworkError) => {
                            if (httpErrorOrNetworkError.responseBody.requestError.messageId === Messages.ESYCC0027.id) {
                                this.setState({
                                    maintenanceMessage: Messages.ESYCC0027.message
                                })
                            } else {
                                eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                            }
                        })

                    let selectedYearMonthIndex = 0
                    if (!isAdminUser) {
                        const issueDate = getQueryParameter('date', this.props.location.search)
                        if (issueDate) {
                            selectedYearMonthIndex = billingYearMonthList.details.indexOf(issueDate)
                        } else {
                            selectedYearMonthIndex = this.props.location.state?.issueYearMonth
                                ? billingYearMonthList.details.indexOf(this.props.location.state.issueYearMonth)
                                : currentYearMonthIndex
                        }

                        if (selectedYearMonthIndex === -1) {
                            this.props.navigate(`/resident/not-found`);
                        }
                    }

                    // 取引金額を取得
                    const billingAmountDetail = await this.props.asyncCallFunction(
                        this.props.amountFixRepo.getBillingAmountDetail.bind(
                            amountFixRepo,
                            condominiumCd,
                            ridgeCd,
                            roomNumber,
                            billingYearMonthList.details[selectedYearMonthIndex]
                        ),
                        (httpErrorOrNetworkError) => {
                            if (httpErrorOrNetworkError.responseBody.requestError.messageId === Messages.ESYCC0027.id) {
                                this.setState({
                                    maintenanceMessage: Messages.ESYCC0027.message
                                })
                            } else {
                                eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                            }
                        })

                    if (billingAmountLatest?.details && billingAmountDetail?.details) {
                        this.setState({
                            billingYearMonthList: billingYearMonthList.details,
                            billingAmountLatest: billingAmountLatest,
                            billingAmountDetail: billingAmountDetail,
                            currentYearMonthIndex: selectedYearMonthIndex,
                            isNotPayComplete:
                                billingAmountDetail.details.paymentStatus === PAYMENT_STATUES.IN_REQUEST.value
                        })
                    }
                    if (!isAdminUser) {
                        // 請求額閲覧状況登録
                        await this.postBillingAmountFixAlreadyView();
                    }
                }
            }
            // メインユーザの氏名を取得
            if ((!haveAuthViewBillingAmount || !haveAuthIssueReceipt) && isSubUser) {
                await this.setupMainUserName()
            }

        } finally {
            this.props.eventEmitter.closeLoading();
            this.setState({
                isLoadCompleted: true
            })
        }
    }

    // 請求額閲覧状況登録
    async postBillingAmountFixAlreadyView(): Promise<void> {
        const {amountFixRepo, condominiumCd, eventEmitter} = this.props
        const {ridgeCd, roomNumber} = this.state

        const seq = await this.getSelectedSeq(condominiumCd, ridgeCd, roomNumber)
        if (seq) {
            const request: NatPutBillingAmountFixAlreadyViewRequest = {
                condominiumCd: condominiumCd,
                ridgeCd: ridgeCd,
                roomNumber: roomNumber,
                seq: seq
            };
            const response =
                await this.props.asyncCallFunction(
                    this.props.amountFixRepo.postBillingAmountFixAlreadyView.bind(
                        amountFixRepo,
                        request),
                    (httpErrorOrNetworkError) => {
                        eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                    })
            if (response?.requestError === null) {
                this.setState({
                    seq: seq
                })
            }
        }
    }

    // 連番取得
    async getSelectedSeq(condominiumCd: string, ridgeCd: string, roomNumber: string): Promise<Nullable<number>> {
        const residentUserInvolvingSubResponse = await this.props.asyncCallFunction(
            this.props.residentUserRepo.getResidentUserInvolvingSub.bind(
                this.props.residentUserRepo, condominiumCd, ridgeCd, roomNumber),
            (httpErrorOrNetworkError) => {
                this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            })
        const loginUserId = SessionStorageHelper.getStringItemOrNull(KEY_USER_ID);
        if (residentUserInvolvingSubResponse?.details) {
            const mainUser = residentUserInvolvingSubResponse.details.mainUser
            const subUsers = residentUserInvolvingSubResponse.details.subUser
            if (mainUser.userId === loginUserId) {
                return mainUser.seq;
            } else {
                const targetSubUser = subUsers.find(subUser => subUser.userId === loginUserId)
                if (targetSubUser) {
                    return targetSubUser.seq;
                }
            }
        }
        return null;
    }

    async updateBillingAmountDetail(billingYearMonth: string): Promise<void> {
        const {amountFixRepo, condominiumCd, eventEmitter} = this.props
        const {ridgeCd, roomNumber} = this.state

        await this.props.eventEmitter.showLoading();
        try {
            // 取引金額を取得
            const billingAmountDetail = await this.props.asyncCallFunction(
                this.props.amountFixRepo.getBillingAmountDetail.bind(
                    amountFixRepo,
                    condominiumCd,
                    ridgeCd,
                    roomNumber,
                    billingYearMonth
                ),
                (httpErrorOrNetworkError) => {
                    if (httpErrorOrNetworkError.responseBody.requestError.messageId === Messages.ESYCC0027.id) {
                        this.setState({
                            maintenanceMessage: Messages.ESYCC0027.message
                        })
                    } else {
                        eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                    }
                })

            if (billingAmountDetail?.details) {
                this.setState({
                    billingAmountDetail: billingAmountDetail,
                    isNotPayComplete:
                        billingAmountDetail.details.paymentStatus === PAYMENT_STATUES.IN_REQUEST.value
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading();
        }
    }

    async setupMainUserName(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        const {residentUserRepo, eventEmitter} = this.props
        try {
            const residentUserResponse = await this.props.asyncCallFunction(
                residentUserRepo.getResidentUserLogined.bind(residentUserRepo),
                (httpErrorOrNetworkError) => {
                    eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                }
            )
            if (residentUserResponse?.details?.mainResidentUserInfo) {
                const {familyName, firstName} = residentUserResponse.details.mainResidentUserInfo

                this.setState({
                    mainUserName: `${familyName} ${firstName}`
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    // 請求書一覧を開く
    handleDialogClick(): void {
        this.setState({dialogStatus: true})
    }

    // 請求書一覧を閉じる
    handleDialogCancelClick(): void {
        this.setState({dialogStatus: false})
    }

    // 請求書をクリック
    async invoiceFileClick(date: string): Promise<void> {
        const {condominiumCd, eventEmitter} = this.props
        const {ridgeCd, roomNumber} = this.state

        const isSutekiNetSmartPhoneApplication = SessionStorageHelper
            .getStringItemWithDefault('isSutekiNetSmartPhoneApplication', 'false')

        await eventEmitter.showLoading()
        try {
            // 請求書ダウンロード
            const tempLink: HTMLAnchorElement = document.createElement('a')
            tempLink.href = `/api/resident/condominiums/${condominiumCd}/ridges/${ridgeCd}/rooms/${roomNumber}/billing-amount/${date}`
            if (isSutekiNetSmartPhoneApplication === 'true') {
                tempLink.target = '_blank'
            }
            document.body.appendChild(tempLink)
            tempLink.click()
            document.body.removeChild(tempLink)
        } finally {
            eventEmitter.closeLoading()
        }
    }

    // 前月
    prevMonthClick(): void {
        const {currentYearMonthIndex, billingYearMonthList} = this.state
        if (billingYearMonthList && (currentYearMonthIndex < billingYearMonthList.length - 1)) {
            this.updateBillingAmountDetail(billingYearMonthList[currentYearMonthIndex + 1])
            this.setState({
                currentYearMonthIndex: currentYearMonthIndex + 1
            })
        }
    }

    // 翌月
    nextMonthClick(): void {
        const {billingYearMonthList, currentYearMonthIndex} = this.state
        if (billingYearMonthList && currentYearMonthIndex > 0) {
            this.updateBillingAmountDetail(billingYearMonthList[currentYearMonthIndex - 1])
            this.setState({
                currentYearMonthIndex: currentYearMonthIndex - 1
            })
        }
    }

    // 請求年月選択
    handleBillingYearMonthChange(event: React.ChangeEvent<HTMLSelectElement>): void {
        const {billingYearMonthList} = this.state
        if (billingYearMonthList) {
            const selectIndex = billingYearMonthList.indexOf(event.target.value)
            this.updateBillingAmountDetail(billingYearMonthList[selectIndex])
            this.setState({
                currentYearMonthIndex: selectIndex
            })
        }
    }

    // 取引内容開く
    tradingDetailClick(): void {
        this.setState({
            isTradingDetailOpen: !this.state.isTradingDetailOpen
        })
    }

    // 内訳内容開く
    breakdownOpenClick(index: number): void {
        const {isBreakdownOpen} = this.state
        const newIsBreakdownOpen = [...isBreakdownOpen]
        newIsBreakdownOpen[index] = !newIsBreakdownOpen[index]
        this.setState({
            isBreakdownOpen: newIsBreakdownOpen
        })
    }

    // 領収書発行へ
    async receiptIssueButtonClick(): Promise<void> {
        const {condominiumCd} = this.props
        const {
            ridgeCd, roomNumber, billingYearMonthList, currentYearMonthIndex,
            billingAmountDetail, mainUserName, haveAuthIssueReceipt, isAdminUser
        } = this.state

        const seq = await this.getSelectedSeq(condominiumCd, ridgeCd, roomNumber);

        if (billingYearMonthList && billingAmountDetail) {
            this.props.navigate(
                `/resident/condominiums/${condominiumCd}/billingAmountConfirm/receiptIssue`,
                {
                    state: {
                        ridgeCd: ridgeCd,
                        roomNumber: roomNumber,
                        seq: seq,
                        issueYearMonth: billingYearMonthList[currentYearMonthIndex],
                        variableTrading: billingAmountDetail.details.variableTrading,
                        receiptIssueStatus: billingAmountDetail.details.receiptIssueStatus,
                        mainUserName: mainUserName,
                        haveAuthIssueReceipt: haveAuthIssueReceipt
                    }
                }
            )
        }
    }

    renderHaveAuthViewBillingAmount(): Nullable<ReactElement> {
        const {billingYearMonthList, isAdminUser} = this.state
        return (<>
                {billingYearMonthList
                    ? <>
                        <Container>
                            {this.renderBillingAmountCard()}
                            <div style={{flex: 1}}>
                                {this.renderBillingYearMonthArea()}
                                {this.renderBillingStatusArea()}
                                {this.renderDetailArea()}
                                {this.renderReceiptIssueButton()}
                            </div>
                        </Container>
                        <BlockSpacer height={'15px'}/>
                        <ListGridContainer fontSize={FontSize.Middle}>
                            <div>・</div>
                            <div>
                                {isAdminUser
                                    ? billingYearMonthList[0]
                                    : getFormattedYearMonth(billingYearMonthList[billingYearMonthList.length - 1])}
                                以降の請求金額が確認できます。
                            </div>
                            <div>・</div>
                            <div>請求金額の閲覧期限は2年間のため、必要に応じて請求書をダウンロードし保管してください。</div>
                            <div>・</div>
                            <div>領収書の発行も2年間まで可能です。それ以前の領収内容についてはお問い合わせください。</div>
                            <div>・</div>
                            <div>当月の請求金額には、預り金や未納分が含まれます。</div>
                            <div>・</div>
                            <div>お支払い状況が完了になると、領収書の発行ができます。</div>
                            <div>・</div>
                            <div>お支払いの結果が、お支払い状況に反映されるまでにお時間がかかる場合があります。</div>
                            <div>・</div>
                            <div>会計システムのサーバーメンテナンスのため、一時的にご利用できない場合があります。</div>
                        </ListGridContainer>
                        <BlockSpacer height={'15px'}/>
                        <NatResidentBillingDataContactUs/>
                        <BlockSpacer height={'15px'}/>
                    </>
                    : <>管理費等お知らせはありません
                        <ListGridContainer fontSize={FontSize.Small} style={{paddingTop:'10px'}}>
                            <div>※</div>
                            <div>請求が発生していないか、請求情報の準備中です。</div>
                            <div/>
                            <div>請求情報が表示されるまで数日程度かかる場合があります。</div>
                            <div/>
                            <div>しばらく時間をおいてご確認ください。</div>
                        </ListGridContainer>
                    </>
                }
            </>
        )
    }

    renderNotHaveAuthViewBillingAmount(): Nullable<ReactElement> {
        const {mainUserName} = this.state
        return (<>
                <Box fontWeight={FontWeights.Bold} color={Colors.Alert}>
                    本機能はご利用いただけません。<br/>
                    ご利用になる場合は、メインユーザの{mainUserName}さんにご確認ください。<br/>
                    メインユーザアカウントの「個人設定＞ユーザ管理」から利用制限の設定を変更できます。
                </Box>
                <BlockSpacer height={'20px'}/>
            </>
        )
    }

    renderBillingAmountCard(): Nullable<ReactElement> {
        const {billingYearMonthList, billingAmountLatest, billingAmountDetail, dialogStatus, isAdminUser} = this.state
        if (!billingYearMonthList || !billingAmountLatest || !billingAmountDetail) {
            return null
        }
        return (
            <div>
                <BlueCard>
                    <MiddleFontBold>
                        {isAdminUser
                            ? billingYearMonthList[0]
                            : getFormattedYearMonth(billingYearMonthList[0])}分 ご請求金額
                    </MiddleFontBold>
                    <BlockSpacer height={'30px'}/>
                    <ExtraBigFontBold>
                        {isAdminUser
                            ? billingAmountLatest.details.billingAmount
                            : Number(billingAmountLatest.details.billingAmount).toLocaleString()}
                        <span style={{fontSize: `${FontSize.Accent}`}}> 円</span>
                    </ExtraBigFontBold>
                    <BlockSpacer height={'20px'}/>
                    <Divider/>
                    <CardInfoRow>
                        <span>請求金額確定日</span>
                        <MiddleFontBold>
                            {isAdminUser
                                ? billingAmountLatest.details.billingAmountFixedDate
                                : getFormattedYearMonthDay(billingAmountLatest.details.billingAmountFixedDate)}
                        </MiddleFontBold>
                    </CardInfoRow>
                    <Divider/>
                    <CardInfoRow>
                        <span>口座引落日（振込期限）</span>
                        <MiddleFontBold>
                            {isAdminUser
                                ? billingAmountLatest.details.directDebitDate
                                : getFormattedYearMonthDay(billingAmountLatest.details.directDebitDate)}
                        </MiddleFontBold>
                    </CardInfoRow>
                </BlueCard>
                <InvoiceDiv>
                    <BlockSpacer height={'10px'}/>
                    ご請求金額の詳細内訳は請求書をご確認ください。
                    <BlockSpacer height={'10px'}/>
                    <RightRowFlexContainer>
                        <StyledLink onClick={this.handleDialogClick}>
                            請求書の一覧を見る
                        </StyledLink>
                    </RightRowFlexContainer>
                </InvoiceDiv>
                <ResponsiveDialog
                    id={'pp-dialog'}
                    open={dialogStatus}
                    transitionDuration={(process.env.NODE_ENV === 'test') ? 0 : undefined}
                    fullWidth
                >
                    <DialogArea>
                        <RowFlexContainer>
                            <DialogTitle>請求書</DialogTitle>
                            <DialogCloseButton onClick={this.handleDialogCancelClick}>
                                <Close style={{fontSize: FontSize.Big}}/>
                            </DialogCloseButton>
                        </RowFlexContainer>
                        <BlockSpacer height={'15px'}/>
                        <Divider $color={Colors.Background}/>
                        <BlockSpacer height={'15px'}/>
                        {isAdminUser
                            ? <>請求書はありません</>
                            : billingYearMonthList.map((date, index) => (
                                <AttachmentFile key={index}>
                                    <div onClick={() => this.invoiceFileClick(date)} style={{cursor: 'pointer'}}>
                                        <FullWidthLeftRowFlexContainer>
                                            <FontAwesomeIcon icon={faFilePdf} color={'#FF6378'} size={'lg'}/>
                                            <AttachmentFileName>
                                                {'ご請求金額のお知らせ_' + getFormattedYearMonth(date)}
                                            </AttachmentFileName>
                                            <GetApp style={{color: Colors.Body, fontSize: FontSize.Accent}}/>
                                        </FullWidthLeftRowFlexContainer>
                                    </div>
                                </AttachmentFile>
                            ))
                        }
                    </DialogArea>
                </ResponsiveDialog>
            </div>
        )
    }

    renderBillingYearMonthArea(): Nullable<ReactElement> {
        const {billingYearMonthList, currentYearMonthIndex, isAdminUser} = this.state
        if (!billingYearMonthList) {
            return null
        }
        return (
            <>
                <WhiteArea>
                    <DisplayItemTitle>お取引内容</DisplayItemTitle>
                    <BlockSpacer height={'20px'}/>
                    <BillingYearMonthArea>
                        <PlainLinkStyledBackButton
                            onClick={this.prevMonthClick}
                            disabled={currentYearMonthIndex === billingYearMonthList.length - 1}>
                            前月
                        </PlainLinkStyledBackButton>
                        <SelectIcon>
                            <SelectArea onChange={this.handleBillingYearMonthChange}
                                        value={billingYearMonthList[currentYearMonthIndex]}>
                                {billingYearMonthList.map((value, index) => {
                                    return (
                                        <option key={index} value={value}>
                                            {isAdminUser
                                                ? value
                                                : getFormattedYearMonth(value)}
                                        </option>
                                    )
                                })}
                            </SelectArea>
                        </SelectIcon>
                        <PlainForwardLinkStyledButton
                            onClick={this.nextMonthClick}
                            disabled={currentYearMonthIndex === 0}>
                            翌月
                        </PlainForwardLinkStyledButton>
                    </BillingYearMonthArea>
                </WhiteArea>
            </>
        )
    }

    renderBillingStatusArea(): Nullable<ReactElement> {
        const {billingYearMonthList, currentYearMonthIndex, billingAmountDetail, isAdminUser} = this.state
        if (!billingYearMonthList || !billingAmountDetail) {
            return null
        }
        const tradingMonth = isAdminUser
            ? 'ー'
            : String(Number(billingYearMonthList[currentYearMonthIndex].slice(4)))
        return (
            <>
                <BlockSpacer height={'1px'}/>
                <WhiteArea>
                    <DetailMiddleArea>
                        <MiddleFontBold>{tradingMonth}月分合計</MiddleFontBold>
                        <BigFontBold>
                            {isAdminUser
                                ? billingAmountDetail.details.billingAmount
                                : Number(billingAmountDetail.details.billingAmount).toLocaleString()}
                            <span style={{fontSize: `${FontSize.Middle}`}}> 円</span>
                        </BigFontBold>
                    </DetailMiddleArea>
                    <BlockSpacer height={'20px'}/>
                    <DetailMiddleArea>
                        <StatusSpan>お支払い状況</StatusSpan>
                        <span>
                            {billingAmountDetail.details.paymentStatus === PAYMENT_STATUES.IN_REQUEST.value
                                ? 'ー'
                                : PAYMENT_STATUES.codeToEnumConstants(billingAmountDetail.details.paymentStatus).label}
                        </span>
                    </DetailMiddleArea>
                    <BlockSpacer height={'15px'}/>
                </WhiteArea>
            </>
        )
    }

    renderDetailArea(): Nullable<ReactElement> {
        const {billingYearMonthList} = this.state
        if (!billingYearMonthList) {
            return null
        }
        return (
            <>
                {this.renderTradingArea()}
                {this.renderVariableBreakdownArea()}
            </>
        )
    }

    renderTradingArea(): Nullable<ReactElement> {
        const {billingAmountDetail, isAdminUser} = this.state
        if (!billingAmountDetail?.details.variableTrading) {
            return null
        }
        return (
            <>
                <BlockSpacer height={'1px'}/>
                <WhiteArea>
                    <Headline onClick={this.tradingDetailClick}>
                        取引内容
                        <SmallExpandButton open={this.state.isTradingDetailOpen}/>
                    </Headline>
                    <Collapse in={this.state.isTradingDetailOpen}>
                        <BlockSpacer height={'20px'}/>
                        <Divider $color={Colors.AccentLight}/>
                        {billingAmountDetail.details.variableTrading.map((item, key) => (
                            <NatResidentBillingDetailItem
                                key={key}
                                title={item.expenseItemName}
                                yearMonth={item.accountingYearMonth}
                                amount={item.amount}
                                isAdminUser={isAdminUser}
                            />
                        ))
                        }
                        <BlockSpacer height={'10px'}/>
                    </Collapse>
                </WhiteArea>
            </>
        )
    }

    renderVariableBreakdownArea(): Nullable<ReactElement> {
        const {billingAmountDetail, isBreakdownOpen, isAdminUser} = this.state
        if (!billingAmountDetail?.details.variableBreakdown) {
            return null
        }
        return (
            <>
                {billingAmountDetail.details.variableBreakdown.map((variableBreakdown, index) => (
                    <div key={index}>
                        <BlockSpacer height={'1px'}/>
                        <WhiteArea>
                            <Headline onClick={() => this.breakdownOpenClick(index)}>
                                {variableBreakdown.breakdownName}
                                <SmallExpandButton open={isBreakdownOpen[index]}/>
                            </Headline>
                            <Collapse in={isBreakdownOpen[index]}>
                                <BlockSpacer height={'20px'}/>
                                <Divider $color={Colors.AccentLight}/>
                                {variableBreakdown.variableBreakdownDetail.map((item, i) => (
                                    <NatResidentBillingDetailItem
                                        key={i}
                                        title={item.expenseItemName}
                                        displayValue={item.value}
                                        isAdminUser={isAdminUser}
                                    />
                                ))
                                }
                                <BlockSpacer height={'10px'}/>
                            </Collapse>
                        </WhiteArea>
                    </div>
                ))
                }
            </>
        )
    }

    renderReceiptIssueButton(): Nullable<ReactElement> {
        const {billingYearMonthList, isNotPayComplete} = this.state
        if (!billingYearMonthList) {
            return null
        }
        return (
            <>
                <BlockSpacer height={'1px'}/>
                <WhiteArea style={{textAlign: 'center'}}>
                    <BlockSpacer height={'10px'}/>
                    <SecondaryButton onClick={this.receiptIssueButtonClick} disabled={isNotPayComplete}>
                        領収書発行へ
                    </SecondaryButton>
                    {
                        isNotPayComplete &&
                        <>
                            <BlockSpacer height={'5px'}/>
                            <span style={{fontSize: `${FontSize.Small}`, color: `${Colors.AccentDark}`}}>
                                ※お支払い状況が完了になると、発行できます
                            </span>
                        </>
                    }

                    <BlockSpacer height={'10px'}/>
                </WhiteArea>
            </>
        )
    }

    renderMaintenanceMassageArea(): Nullable<ReactElement> {
        const {maintenanceMessage} = this.state
        return (
            <WhiteMessageArea>
                <PreformattedDiv>{maintenanceMessage}</PreformattedDiv>
            </WhiteMessageArea>
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }
        const {haveAuthViewBillingAmount} = this.state
        return (
            <>
                <BlockSpacer height={'15px'}/>
                <StyledPageTitle>
                    管理費等お知らせ
                </StyledPageTitle>
                <BlockSpacer height={'20px'}/>
                {!haveAuthViewBillingAmount && this.renderNotHaveAuthViewBillingAmount()}
                管理費等の請求金額を確認できます。お支払いを完了したものは、領収書が発行できます。
                <BlockSpacer height={'20px'}/>
                {this.state.maintenanceMessage ?
                    <>
                        {this.renderMaintenanceMassageArea()}
                        <Box height={'20px'}/>
                        <StyledSecondaryButton
                            onClick={() => this.props.navigate({
                                pathname: '/resident/mypage',
                            })}>
                            ホームへ戻る
                        </StyledSecondaryButton>
                    </>
                    :
                    <>
                        <HeadingAreaMessageComponentForResident eventEmitter={this.props.eventEmitter}/>
                        {haveAuthViewBillingAmount && this.renderHaveAuthViewBillingAmount()}
                    </>
                }
            </>
        )
    }
}

export default createResidentWithErrorHandlingPage(NatResidentBillingAmountConfirmPage)

const Container = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 15px;

    ${currentMedia.lessThan('sp')`
    flex-direction: column;
    align-items: center;
    gap: 20px;
  `};
`

const BlueCard = styled.div`
    width: 375px;
    height: 222px;
    padding: 20px 12px;
    color: white;
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-items: flex-start;
    border-radius: 9px;
    box-sizing: border-box;
    margin-top: 15px;
    background: linear-gradient(113deg, #3198D2 2.14%, #0070B0 23.05%, #00497F 91.6%);

    ${currentMedia.lessThan('sp')`
    width: 345px;
  `};
`

const CardInfoRow = styled.div`
    display: flex;
    justify-content: space-between;
    width: calc(100% - 15px);
    font-size: ${FontSize.Middle};
    margin: 10px 0;
`

const DetailMiddleArea = styled.div`
    width: 345px;
    display: flex;
    margin: 0 auto;
    justify-content: space-between;
    align-items: center;
    font-size: ${FontSize.Middle};
`

const BillingYearMonthArea = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`

const InvoiceDiv = styled.div`
    font-size: ${FontSize.Middle};
    padding-left: 12px;
`

const DialogArea = styled.div`
    background-color: ${Colors.Surface};
    padding: 17px 15px;
    box-sizing: border-box;
    word-break: normal;
    line-break: strict;
    width: 576px;
    max-height: 588px;
    min-height: 300px;
    overflow-x: hidden;

    ${currentMedia.lessThan('sp')`
    width: 100%;
  `}
`

const DialogTitle = styled.div`
    font-size: ${FontSize.Accent};
    font-weight: ${FontWeights.Bold};
    color: ${Colors.AccentDark};
    margin-left: 5px;
`

const DialogCloseButton = styled(UnstyledLinkStyledButton)`
    color: ${Colors.AccentDark};
`

const AttachmentFile = styled.div`
    border: 1px solid #D9D9D9;
    border-radius: 4px;
    margin-bottom: 10px;
    padding: 16px 15px;
    height: 62px;
    box-sizing: border-box;

    &:last-child {
        margin-bottom: 0;
    }
`

const AttachmentFileName = styled.span`
    color: ${Colors.Body};;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    padding-left: 10px;
    padding-right: 10px;
    width: 100%;
`

const WhiteMessageArea = styled(WideMainContainer)`
    padding: 15px;
`
